module.exports = __webpack_public_path__ + "static/media/transporter.32dbbeac.svg";